<template>
  <el-menu
    background-color="#fffff"
    text-color="#333333"
    active-text-color="#5E7FEC"
    :router="true"
    :default-active="defaultActive"
    :default-openeds="defaultOpeneds"
    @select="parkTo"
    @open="handleOpen"
    :collapse="isMenuCollapse"
    :unique-opened="true"
    v-if="showLeftSide"
  >
    <template v-for="item in data">
      <el-submenu :key="item.Id" :title="item.Name" :index="`${item.Id}`">
        <template slot="title">
          <img src="../../../assets/img/icon13.png" width="12" alt="" style="margin-right: 5px;">
          <span slot="title">
            {{ item.Name }}
            <div class="info">余/总: {{item.SpotCanUseCount}}/{{item.SpotCount}} <em></em> 月/临: {{item.BillPackCarNum}}/{{item.CarNum}}</div>
          </span>
        </template>
        <template v-for="items in item.children">
          <el-menu-item
            :key="items.Id"
            :ref="
              `/${tenantId === 18 ? 'ZS' : 'home'}/tenant/${item.Id}/${item.Name}/${items.Id}/${items.Name}`
            "
            :index="
              `/${tenantId === 18 ? 'ZS' : 'home'}/tenant/${item.Id}/${item.Name}/${items.Id}/${items.Name}`
            "
            :title="items.Name"
            >{{ items.Name }}</el-menu-item
          >
        </template>
      </el-submenu>
    </template>
  </el-menu>
</template>
<script>
import { getUserId, getLoginSentryId, getToken } from "@/utils/service";
import Ws from "@/utils/ws";

import {
  parkInPubSub,
  parkOutPubSub,
  userInfoPubSub,
  realInListPubSub,
  realOutListPubSub,
  blackParkInPubSub,
  spotNumPubSub,
} from "../../../service/pubsub/index";
import treeMenu from "@/minxs/treeMenu";

export default {
  name: "treeMenu",
  mixins: [treeMenu],
  data() {
    return {
      defaultActive: "",
      defaultOpeneds: [],
      camTime: null,
      notificationCount: 0,
    };
  },
  props: {
  },
  watch: {
    tenantId: function (v, o) {
      this.$router.push(`/home/tenant`);
      this.server(o);
    },
    isInitWs(v) {
      if (v) {
        this.closeWs();
        this.ws = null;
      }
    },
    treeSentryId(v) {
      if (v && v !== ''){
        this.sentryId = v;
        // console.log(this.sentryId)
        this.server(undefined, 'isSentry');
      }
    },
    gateIdsSortStr: function () {
      // console.log('gateIdsSortStr')
      this.server();
    },
    autoCompleteSelect: function (v) {
      // console.log('autoCompleteSelect', v);
      this.parkTo(v, 'autoCompleteSelect')
    },
    gateIds(v) {
      this.$store.dispatch("SetVideoGateIds", v);
    },
    deviceStatusMsgStr(v) {
      let arr = JSON.parse(v);
      const elements = document.getElementsByClassName('new-notification');
      // console.log(arr, elements)
      if (arr.length > 0) {
        if (elements.length === 0) {
          this.openNotify(arr[arr.length - 1])
        } else {
          let msgArr = [];
          for(let i = 0; i < elements.length; i++) {
            msgArr.push(elements[i].children[1].children[1].children[0].children[0].innerHTML)
          }
          let same = msgArr.filter(val => {return val === arr[arr.length - 1].otherMsg})
          if (same.length === 0) this.openNotify(arr[arr.length - 1])
        }
      }
    },
    showPassInStr(v) {
      this.ShowPassIn = JSON.parse(v);
      // console.log(this.ShowPassIn, this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0])
      setTimeout(() => {
        if (!this.ShowPassIn[this.moreBlackParkIn.lastKey]) this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'clear'});
        if (this.wsOrderArr && this.wsOrderArr.length === 0 && this.moreBlackParkIn[this.moreBlackParkIn.lastKey].length > 0 && !this.showOrderDetail && this.ShowPassIn[this.moreBlackParkIn.lastKey]) {
          if (!this.gateId){
            this.$store.dispatch("SetPayOrderGateId", parseInt(this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0].park_lot_gate_id));
            this.$store.dispatch("SetTabsGateId", this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0].park_lot_gate_id);
          }
          this.$store.dispatch("GetShowOrderDetail", true);
          if (this.moreBlackParkIn[this.moreBlackParkIn.lastKey].length > 0 && this.ShowPassIn[this.moreBlackParkIn.lastKey]) blackParkInPubSub.publish(this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0]);
        }
      }, 600)
    },
  },
  computed: {
    deviceStatusMsgStr: {
      get() {
        return this.$store.state.order.deviceStatusMsgStr
      },
      set(val) {
        this.$emit('update:deviceStatusMsgStr', val);
      }
    },
    deviceStatusMsg: {
      get() {
        return this.$store.state.order.deviceStatusMsg
      },
      set(val) {
        this.$emit('update:deviceStatusMsg', val);
      }
    },
  },
  mounted() {
    this.sentryId = getLoginSentryId() ? Number(getLoginSentryId()) : undefined;
    // this.server();
    // this.initWs();
    this.checkActive();
    this.refreshData();
    if (this.deviceStatusMsg.length === 0 && sessionStorage.getItem('moreDeviceStatusMsg') && sessionStorage.getItem('moreDeviceStatusMsg') !== '[]') {
      let arr = JSON.parse(sessionStorage.getItem('moreDeviceStatusMsg'));
      this.$store.dispatch("SETDeviceStatusMsgStr", arr);
      arr.forEach(v => {
        this.openNotify(v)
      })
    } else {
      this.$store.dispatch("SETDeviceStatusMsg", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'deviceStatus'});
    }
  },
  beforeDestroy() {
    this.$store.dispatch("SetParkLotId", "");
    this.$store.dispatch("SetGateIds", []);
    this.closeWs();
  },
  methods: {
    initWs() {
      try {
        this.ws = new Ws({
          url: this.getBaseUrl(),
          // duration: 30 * 1000 * 60,
          duration: 10000,
          token: getToken(),
          connecting: (data) => {
            let Data = JSON.parse(data);
            // console.log('ws--log--', JSON.parse(Data.otherMsg));
            if (Data === '登陆已过期') {
              this.closeWs();
              this.$store.dispatch("LogOut");
              this.$router.push("/login");
            }
            this.connectWsData(Data).then(wsObj => {
              switch (wsObj.key) {
                case 'parkIn':
                  parkInPubSub.publish(Data);
                  break;
                case 'parkOut':
                  this.$store.dispatch('SETMoreWsData', {obj: wsObj, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreWsData'});
                  if (wsObj.message_type === '5' && wsObj.freeOrderShow !== '0') {
                    setTimeout(() => {
                      this.pubOrder(wsObj);
                      parkOutPubSub.publish(Data);
                    }, 200);
                  } else if (wsObj.message_type === '6') {
                    this.pubOrder(wsObj);
                    parkOutPubSub.publish(Data);
                  }
                  break;
                case 'blackParkIn':
                  if (Data.message_type === "5") Data.SentryId = sessionStorage.getItem('sentryId');
                  this.$store.dispatch('SETMoreBlackParkIn', {obj: Data, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreBlackParkIn'});
                  setTimeout(() => {
                    this.ShowPassIn = JSON.parse(this.$store.state.layout.showPassInStr)
                    if (this.ShowPassIn[sessionStorage.getItem('sentryId')]) {
                      if (this.wsOrderArr && this.wsOrderArr.length === 0 && !this.showOrderDetail) {
                        if (!this.gateId && Data.message_type !== "5"){
                          this.$store.dispatch("SetPayOrderGateId", parseInt(Data.park_lot_gate_id));
                          this.$store.dispatch("SetTabsGateId", Data.park_lot_gate_id);
                        }
                        this.$store.dispatch("GetShowOrderDetail", this.moreBlackParkIn[this.moreBlackParkIn.lastKey].length > 0);
                      }
                      blackParkInPubSub.publish(Data);
                    } else {
                      this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'clear'});
                    }
                  }, 700);
                  break;
                case 'realInOutList':
                  realInListPubSub.publish(Data.passInResult);
                  realOutListPubSub.publish(Data.passOutResult);
                  break;
                case 'userInfo':
                  userInfoPubSub.publish(Data);
                  break;
                case 'spotNum':
                  spotNumPubSub.publish(Data.SpotNum);
                  break;
                case 'parkOut2':
                  this.$store.dispatch('SETMoreWsData', {obj: wsObj, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreWsData'});
                  if (wsObj.freeOrderShow !== '0') this.pubOrder(wsObj);
                  break;
                case 'camStatusData':
                  this.camStatusData = Data.data;
                  break;
                case 'deviceStatus':
                  this.$store.dispatch('SETDeviceStatusMsg', {obj: Data, ParkLotId: sessionStorage.getItem('ParkLotId'), key: 'deviceStatus'});
                  break;
              }
            });
          },
          success: () => {
            this.checkActive();
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    checkActive() {
      let { ParkLotId, ParkLotName, GateId, GateName } = this.$route.params;
      if (Number(ParkLotId) && Number(GateId) && GateName) {
        this.defaultOpeneds = [ParkLotId];
        this.defaultActive =  `/${this.tenantId === 18 ? 'ZS' : 'home'}/tenant/${ParkLotId}/${ParkLotName}/${GateId}/${GateName}`;
        setTimeout(() => {
          this.sendMsgToWs({
            ParkLotId: Number(ParkLotId),
            // SentryBoxId: Number(GateId),
          });
        }, 100);
        setTimeout(() => {
          this.sendMsgToWs({
            ParkLotId: Number(ParkLotId),
            MsgType: 'camStatus'
          })
        },200)
        if (this.camTime) {
          clearInterval(this.camTime)
          this.camTime = null
        }
        this.camTime = setInterval(() => {
          this.sendMsgToWs({
            ParkLotId: Number(ParkLotId),
            MsgType: 'camStatus'
          });
        }, 60000)
      }
    },
    // 获取菜单
    async server(oldTenantId, key) {
      let res = await this.getTreeSentryBox();
      // console.log(res, oldTenantId);
      if (res.data.length > 0) {
        this.$store.dispatch("SETMoreWsData", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreWsData'});
        this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreBlackParkIn'});
        // this.$store.dispatch("SETDeviceStatusMsg", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'deviceStatus'});
        this.initJump(res.data, oldTenantId).then(val => {
          if (val.type === 1) {
            this.parkTo(val.url, key);
          } else {
            this.$router.push(val.url);
            this.parkTo(val.url, key);
          }
        });
        this.handleDataSearch(res.data);
      } else {
        this.data = [];
        this.$router.push(`/home/tenant/0/无数据/0/无数据`);
      }
    },
    // 点击路由
    async parkTo(data, key) {
      if (!this.ws) this.initWs();
      let res = await this.storageRouter(data);
      let ShowPassInArr = {};
      ShowPassInArr[res.sentryId] = this.data.filter(v => {return v.Id === parseInt(res.ParkLotId)})[0].children.filter(v => {return v.Id === parseInt(res.sentryId)})[0].ShowPassIn;
      ShowPassInArr[res.sentryId] = Boolean(ShowPassInArr[res.sentryId]);
      this.$store.dispatch("SetShowPassInStr", JSON.stringify(ShowPassInArr));
      // console.log(this.$store.state.layout.showPassInStr)
      if (data !== this.autoCompleteSelect) {
        this.$store.dispatch("SETMoreWsData", {obj: {}, SentryBoxId: res.sentryId, key: 'moreWsData', });
        this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreBlackParkIn'});
        this.$store.dispatch("SetPayOrderGateId", undefined);
        this.$store.dispatch("SetTabsGateId", undefined);
        this.$store.dispatch("SETAutoCompleteSelect", data);
        this.refreshTreeSentryBox(res.ParkLotId, res.sentryId);
      } else if (data === this.autoCompleteSelect && key) {
        this.refreshTreeSentryBox(res.ParkLotId, res.sentryId);
      }
      this.defaultActive = data;
      this.defaultOpeneds = [res.ParkLotId];
      setTimeout(() => {
        this.sendMsgToWs({
          ParkLotId: Number(res.ParkLotId),
          // SentryBoxId: Number(GateId),
        });
      }, 100);
      setTimeout(() => {
        this.sendMsgToWs({
          ParkLotId: Number(res.ParkLotId),
          MsgType: 'camStatus'
        })
      },200)
      this.$nextTick(() => {
        this.$emit("changeRouter");
      });
    },
    //发送socket数据
    sendMsgToWs(obj) {
      try {
        // obj.IsOpenStream = Number(getRoleCode() === "tenantAdmin" || getRoleCode() === "internalAdmin");
        obj.IsOpenStream = 1;
        obj.TenantUserId = Number(getUserId());
        obj.SentryBoxId = Number(sessionStorage.getItem("sentryId"));
        obj.LastLoginTime = sessionStorage.getItem("lastLoginTime");
        let hartObj = Object.assign({}, obj);
        delete hartObj.MsgType;
        if (this.ws) {
          this.ws.ws.send(JSON.stringify(obj));
          this.ws.setHeartMsg(JSON.stringify(hartObj));
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleDataSearch(dataArr) {
      let arr = [];
      dataArr.forEach(v => {
        v.value = v.Name;
        arr.push(v);
      });
      this.$store.dispatch("SetSearchArr", arr);
    },
    closeWs() {
      if (this.ws){
        this.ws.close();
        this.ws.onclose = function () {
          console.log('websocket 关闭')
        }
      }
    },
    handleOpen(index) {
      // console.log('handleOpen')
      let arr = this.data.filter(v => {
        return parseInt(index) === v.Id
      })
      // console.log(`/home/tenant/${arr[0].Id}/${arr[0].Name}/${arr[0].children[0].Id}/${arr[0].children[0].Name}`)
      this.$router.push(`/home/tenant/${arr[0].Id}/${arr[0].Name}/${arr[0].children[0].Id}/${arr[0].children[0].Name}`);
      this.parkTo(`/home/tenant/${arr[0].Id}/${arr[0].Name}/${arr[0].children[0].Id}/${arr[0].children[0].Name}`);
    },
    openNotify(obj) {
      let _this = this;
      this.$notify.error({
        title: '提示',
        dangerouslyUseHTMLString: true,
        message: `<div data-index="${this.notificationCount}">${obj.otherMsg}</div>` ,
        customClass: 'new-notification',
        duration: 0,
        position: 'top-left',
        onClose(e) {
          setTop(e);
        }
      });
      setTop();
      this.notificationCount++;
      function setTop(e) {
        setTimeout(() => {
          const elements = document.getElementsByClassName('new-notification');
          if (e && elements.length === 1) _this.notificationCount = 0;
          let index = e ? parseInt(e.dom.children[1].children[1].children[0].children[0].dataset.index) : -1;
          if (e) {
            if (index >= _this.deviceStatusMsg.length) index = _this.deviceStatusMsg.length - 1;
            // console.log(index, _this.deviceStatusMsg, _this.deviceStatusMsg[index])
            _this.$store.dispatch('SETDeviceStatusMsg', {obj: _this.deviceStatusMsg[index], key: 'update'});
          } else {
            // _this.$store.dispatch('SETDeviceStatusMsg', {obj: obj, ParkLotId: sessionStorage.getItem('ParkLotId'), key: 'deviceStatus'});
          }
          for (let i = elements.length - 1, j = 0; i >= 0, j < elements.length ; i--, j++) {
            // console.log(elements[i])
            if (index === parseInt(elements[i].children[1].children[1].children[0].children[0].dataset.index)) j--;
            // if (e) console.log(index, i, j)
            elements[i].style.cssText = `top: ${16 + 91 * j}px!important; z-index: 2003;`;
          }
        }, 0);
      }
    },
  },
};
</script>
<style lang="scss">
$primary: #1C1C1E;
$primary: #ffffff;
.layout-sider-menu {
  flex-grow: 1;
  background: $primary;
  color: #fff;
  & .el-tree-node.is-current > .el-tree-node__content {
    background-color: white !important;
    color: $primary;
  }
  & .el-tree-node__content:hover {
    color: $primary;
  }
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #535353;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
}
#app .el-submenu .el-menu-item{
  background: $primary!important;
}
#app .nest-menu .el-submenu > .el-submenu__title:hover, #app .nest-menu .el-submenu > .el-submenu__title.is-active:after,
#app .el-submenu .el-menu-item.is-active:after{
  content: '';
  position: absolute;
  width: 4px;
  height: 100%;
  background: #5E7FEC;
  right: 0;
  top: 0;
}
#app .el-submenu__title{
  background: $primary!important;
  font-weight: bold;
}
#app .el-submenu__title:hover{
  background-color: rgba(94, 127, 236, 0.06)!important;
}
  /********************20220926********************/
#app .el-submenu__title{
  position: relative;
  .info{
    position: absolute;
    line-height: 1;
    bottom: 4px;
    font-size: 12px;
    left: 40px;
    font-weight: normal;
    color: #7F8091;
    em{
      padding-left: 10px;
    }
  }
}
</style>
